import i18next from "i18next";
import { HiOutlineClipboard, HiOutlineCog, HiOutlineCreditCard, HiOutlineHome, HiOutlineTicket, HiOutlineUsers } from "react-icons/hi";
import { HiCalendarDays, HiOutlineMapPin } from "react-icons/hi2";

export const MAIN_MENU = {
  key: 'main',
  title: i18next.t('sidebar.main_function'),
  items: [
    { key: 'overview', text: i18next.t('sidebar.overview'), icon: HiOutlineHome, url: "/" },
    { key: 'application', text: i18next.t('sidebar.application'), icon: HiOutlineClipboard, url: "/applicant" },
    { key: 'issued_card', text: i18next.t('sidebar.issued_card'), icon: HiOutlineCreditCard, url: "/issued-card" },
    { key: 'appointment', text: i18next.t('sidebar.appointment'), icon: HiCalendarDays, url: "/appointment" },
    { key: 'office_location', text: i18next.t('sidebar.office_location'), icon: HiOutlineMapPin, url: "/office-location" },
    { key: 'officer_management', text: i18next.t('sidebar.officer_management'), icon: HiOutlineUsers, url: "/management" },
    { key: 'citizen_management', text: i18next.t('sidebar.citizen_management'), icon: HiOutlineUsers, url: "/citizen-management" },
    { key: 'ticket', text: i18next.t('sidebar.ticket'), icon: HiOutlineTicket, url: "/ticket" },
  ],
};

export const OTHER_MENU = {
  key: 'other',
  title: i18next.t('sidebar.other'),
  items: [
    { key: 'settings', text: i18next.t('sidebar.settings'), icon: HiOutlineCog, url: "/settings" },
  ],
};